import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
//-------------------------------------------------
import magnifierImg from "src/img/magnifier.png";
import Resize from "src/components/common/resize";
import { useMyStore } from "src/components/main/mainStore";
import {
    MyFormData,
    myAxios,
    numberReducer,
    onlyUnique, 
    defaultPath,
    appTitle
} from "src/components/common/functions";
//-------------------------------------------------
export default function Search({ tabTitle }){
    // replace
    // add search and options to url params
    //-------------------------------------------------
    const curUser = useMyStore(state => state.user);
    const [rootPath, setRootPath] = useState(`${defaultPath}/besstestlab`);
    const [data, setData] = useState([]);
    const [showLoading, setShowLoading] = useState(false);
    const [search, setSearch] = useState({autocomplete: false, caseSensitive: false, wholeWord: false, needle: ""});
    //-------------------------------------------------
    const handleSearch = async() => {
        //------------------------
        setShowLoading(true);
        const formData = new MyFormData();
        formData.append("rootPath", rootPath);
        formData.append("autocomplete", search.autocomplete);
        formData.append("caseSensitive", search.caseSensitive);
        formData.append("wholeWord", search.wholeWord);
        formData.append("needle", search.needle);
        const res = await myAxios("server/search.php", formData);
        setShowLoading(false);
        if(!res) return;
        //------------------------
        setData(res.data);
    }
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{backgroundColor: curUser.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {search.needle}
                        onChange = {e => {
                            const value = e.currentTarget.value;
                            setSearch(search => ({
                                ...search, 
                                needle: value
                            }));
                        }}
                        onKeyDown = {e => {
                            if(e.key === "Enter"){
                                handleSearch();      
                            }
                        }}
                    />
                    <img
                        alt = ""
                        src = {magnifierImg}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "path" className = "mb-0">Path:</label>
                    <select
                        id = "path"
                        className = "form-control w-auto ml-2"
                        value = {rootPath}
                        onChange = {e => {
                            setRootPath(e.currentTarget.value)
                        }}
                    >
                        <option value = {`${defaultPath}/besstestlab`}>Bess Utility Solutions</option>
                        <option value = {`${defaultPath}/bessmti`}>Material Testing Inspection</option>
                        <option value = {""}>All</option>
                    </select>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "matchCase" className = "mb-0">Match Case:</label>
                    <input
                        id = "matchCase"
                        type = "checkbox"
                        className = "cssCheckBox ml-2"
                        checked = {search.caseSensitive}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            setSearch(search => ({
                                ...search,
                                caseSensitive: checked
                            }))
                            
                        }}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "autoComplete" className = "mb-0">AutoComplete:</label>
                    <input
                        id = "autoComplete"
                        type = "checkbox"
                        className = "cssCheckBox ml-2"
                        checked = {search.autocomplete}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            setSearch(search => ({
                                ...search,
                                autocomplete: checked,
                                wholeWord: checked? false : search.wholeWord
                            }))
                            
                        }}
                    />
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "matchWholeWord" className = "ml-3 mb-0">Match Whole Word:</label>
                    <input
                        id = "matchWholeWord"
                        type = "checkbox"
                        className = "cssCheckBox ml-2"
                        checked = {search.wholeWord}
                        onChange = {e => {
                            const checked = e.currentTarget.checked;
                            setSearch(search => ({
                                ...search,
                                wholeWord: checked,
                                autocomplete: checked? false : search.autocomplete
                            }))
                        }}
                    />
                </span>
                {search.needle?
                <span
                    className = "pointer"
                    onClick = {handleSearch}
                >
                    Submit
                </span>
                :<></>}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !data.length?<div className = "cssLoading">Empty</div>:
                <div>
                    {data.length?
                    <h3 className = "text-info">
                        Found {search.autocomplete?data.map(d => d.matches?.length ?? 0).reduce(numberReducer, 0):data.length} result(s) in {data.map(d => d.path).filter(onlyUnique).length} file(s)
                    </h3>
                    :<></>}
                    {data.map(d => d.path).filter(onlyUnique).map((path, pathIndex) => 
                    <div key = {pathIndex} className = "my-4">
                        <Link to = {`/FileExplorer?path=${path}&searchQuery=${search.needle}`} className = "h4" style = {{wordBreak: "break-all"}}>{path}</Link>
                        <span className = "h5 text-success ml-2">{search.autocomplete?data.find(d => d.path === path)?.matches?.length ?? 0:data.filter(d => d.path === path).length} result(s)</span>
                        {data.filter(d => d.path === path).map((item, itemIndex) => 
                        <h5 key = {itemIndex}>
                            {search.autocomplete?
                            <>{item.matches?.map((match, matchIndex) => <li key = {matchIndex}>{match}</li>)}</>:
                            <li><span className = "text-secondary">{itemIndex + 1}.</span> lines: {item.lines} : {item.pos}</li>}
                        </h5>)}
                </div>)}
                </div>}
            </div>
        </div>
    )
}